import React from 'react'
import { Field, PanelTitle } from './InventoryShared';

function ConversionPage({ title, items }) {
    return (
        <section className='inventory-panel inventory-form-page'>
            <PanelTitle title={title} />
            <div className='inventory-form-grid two-column'>
                <Field label='Source Item' type='select' options={items.map(item => item.name)} />
                <Field label='Source Quantity' type='number' placeholder='10' />
                <Field label='Output Item' type='select' options={items.map(item => item.name)} />
                <Field label='Output Quantity' type='number' placeholder='8' />
                <Field label='Loss / Yield %' type='number' placeholder='80' />
            </div>
            <div className='inventory-actions sticky'><button>Save</button></div>
        </section>
    );
}

export default ConversionPage
